/*
  mem-game contains the game logic
*/
(function () {

  function gameBoard(tileChars) {
    return tileChars.map(function (char) {
      return {
        value: char,
        flipped: false
      };
    });
  }

  function Game(options) {
    var board = gameBoard(options.tiles),
      lives = options.lives || Math.ceil(board.length / 1.75),
      originalLives = lives,
      startTime = new Date(),
      game = { },
      previousTile;

    function gameIsWon() {
      return board.every(function (tile) { return tile.flipped; });
    }

    function gameIsLost() {
      return lives <= 0;
    }

    function evaluateWon() {
      if (gameIsWon()) {
        $(game).trigger('won');
      }
    }

    function evaluateLost() {
      if (gameIsLost()) {
        $(game).trigger('lost');
      }
    }

    function onmatch() {
      $(game).trigger('match');
    }

    function onmismatch(tile) {
      --lives;
      $(game).trigger('mismatch');
      tile.flipped = (previousTile.flipped = false);
    }

    function setPreviousTile (tile) {
      previousTile = tile;
    }

    function evaluateMatch(tile) {
      if (previousTile.value === tile.value) {
        onmatch(tile);
        evaluateWon();
      } else {
        onmismatch(tile);
        evaluateLost();
      }

      previousTile = undefined;
    }

    function ontileFlipped(tile) {
      if (!previousTile) {
        setPreviousTile(tile);
      } else {
        evaluateMatch(tile);
      }
    }

    function flipTile (index) {
      var tile = board[index];

      if (!tile.flipped) {
        tile.flipped = true;

        ontileFlipped(tile);
      }

      return tile;
    };

    game.time = function() { return new Date() - startTime };

    game.errors = function() { return originalLives - lives };

    game.lives = function () { return lives };

    game.tiles = function () { return board };

    game.flipTile = flipTile;

    return game;
  }

  mem.Game = Game;

})();
